
<template>
  <div>
    <BuildingSelect ref="address_select" :shipping="order.shipping" :client_id="order.client_id"></BuildingSelect>
  </div>
</template>

<script>

export default {
  name: 'SelectWholesaleAddress',
  components:{
    AddressSelect: () => import("@/components/create_order/shared/AddressSelect.vue"),
    BuildingSelect: () => import("@/components/create_order/shared/BuildingSelect.vue"),
    AddressForm:() => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
  },
  props: {
    order: {
      type: [Object],
    },
  },
  data(){
    return {
    }
  },
  methods: {
    validate(){
      return this.$refs.address_select.validate()
    },
    resetAddress(){
      this.order.client_shipping_location_attributes.address_attributes = {
        zip: null,
        addr: null,
        neighborhood: null,
        number: null,
        complement: null,
        city: null,
        state: null,
      }
    },
  },
  mounted(){
  },
  watch: {
  },
}
</script>